import { create } from "zustand";

const initialError = {
  intensity: "",
  message: "",
  err: {},
  show: false,
  errorCode: "500",
};

export const selectError = (state) => state.error;

const useErrorStore = create((set) => ({
  error: { ...initialError },
  setError: (payload) => set({ error: { intensity: "low", show: true, ...payload } }),
  resetError: () => set({ error: { ...initialError } }),
}));

export default useErrorStore;
